import { CheckCircle2, XCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { InsuranceItem } from "@/types/api";

interface InsuranceChecklistProps {
  items: InsuranceItem[];
}

export function InsuranceChecklist({ items }: InsuranceChecklistProps) {
  const passCount = items.filter((i) => i.status === "pass").length;

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">Insurance Readiness</CardTitle>
          <span className={cn(
            "text-xs font-medium rounded-full px-2 py-0.5",
            passCount === items.length
              ? "bg-green-500/10 text-green-400"
              : "bg-yellow-500/10 text-yellow-400"
          )}>
            {passCount}/{items.length} passing
          </span>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        {items.map((item) => (
          <div key={item.item} className="flex items-start gap-3">
            {item.status === "pass" ? (
              <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-green-500" />
            ) : (
              <XCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-500" />
            )}
            <div>
              <p className="text-sm font-medium">{item.item}</p>
              <p className="text-xs text-muted-foreground">{item.detail}</p>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
